{
	"ariaSelectCoverImage": "Select AI Style Cover Image",
	"dropImage": "Drop a jpeg image here",
	"or": "Or",
	"pleaseSelectAJpegFile": "Please select a JPEG file.",
	"pleaseSelectUpTo1": "Please select up to 1 image.",
	"selectImages": "Select Images"
}
